import { SecurityToken } from "@models/asset/cryptocoins/currencies/security_token";
import { AssetService } from "@main-services/currency/asset.service";
import { InitService } from "@core-services/init.service";
import { SocketService } from "@main-services/socket.service";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root"
})
export class SecurityTokenService extends AssetService<SecurityToken> {
	public constructor(
		protected initService: InitService,
		protected socketService: SocketService,
		protected destructor: DestructorService,
		protected translationService: TranslationService
	) {
		super(initService, destructor, translationService, socketService, "SecurityTokenService");
	}

	public logoUrl(item: SecurityToken, grayVersion: boolean = false): string {
		// This function needs to exist
		return "";
	}

	public startSockets(): void {
		// We don't have socket but this function needs to exist
	}
}
